// The API this app talks to.
//
// Production is the default, so a plain `npm run build` is always correct even
// when the working tree has been pointed somewhere else for local work. To run
// against a backend on this machine, put these lines in
// `.env.development.local`, which is gitignored and read only by `npm start`:
//
//   REACT_APP_BACKEND_URL=http://localhost:3001
//   REACT_APP_PUBLIC_URL=http://localhost:3000
//
// Deliberately not `.env.local`: that file is read by production builds too,
// which is exactly how a deploy ends up shipping a localhost API.
export const backendDomain =
  process.env.REACT_APP_BACKEND_URL || "https://auctionbackend.spectors.in";

// Where the public pages live: the live board, the auction pool and the teams
// board. The admin only ever links out to them, and every one of those links
// is the session id on the end of a path, so they are built from here rather
// than written out three times.
export const publicDomain =
  process.env.REACT_APP_PUBLIC_URL || "https://auction.spectors.in";

export const publicLinks = (sessionId) => [
  {
    key: "live",
    text: "Live board",
    hint: "What the room watches: the player on the block and the bidding.",
    url: `${publicDomain}/live/${sessionId}`,
  },
  {
    key: "pool",
    text: "Auction pool",
    hint: "Every player by category, and what they went for.",
    url: `${publicDomain}/playerlist/${sessionId}`,
  },
  {
    key: "teams",
    text: "Teams",
    hint: "Every squad as it stands, by role.",
    url: `${publicDomain}/teams/${sessionId}`,
  },
];
